import React from 'react';
import {Box} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';

function LanguageCode({
  code,
  isSelected,
}: {
  code: string;
  isSelected?: boolean;
}) {
  return (
    <Box
      height="24px"
      minWidth={code.length <= 2 ? '25px' : 'auto'}
      bgcolor={
        isSelected
          ? designSystemToken('semantic.bg.brand-secondary')
          : designSystemToken('semantic.bg.tertiary')
      }
      borderRadius="6px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      <Body
        size="md"
        fontWeight="medium"
        letterSpacing="0.16px"
        padding="3px"
        color={
          isSelected
            ? designSystemToken('semantic.fg.brand')
            : designSystemToken('semantic.fg.secondary')
        }
      >
        {code.toUpperCase()}
      </Body>
    </Box>
  );
}

export default LanguageCode;
